var _style, _circle, _g, _g2, _g3, _path, _path2, _circle2, _circle3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBrokenKey = function SvgBrokenKey(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Broken_Key",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 140",
    style: {
      enableBackground: "new 0 0 140 140"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECF0F2;}\n\t.st1{fill:#FFD00B;}\n\t.st2{fill:#97ACB5;}\n\t.st3{fill:#688492;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 70,
    cy: 70,
    r: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.8,49.7c-0.1-0.1-0.2-0.2-0.2-0.4l-0.2-11.2c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6l0.2,11.2 c0,0.3-0.3,0.6-0.6,0.6C77.1,49.9,76.9,49.9,76.8,49.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.2,50.9c0,0-0.1-0.1-0.1-0.1l-4.9-10.1c-0.2-0.3,0-0.7,0.3-0.8c0.3-0.2,0.7,0,0.8,0.3l4.9,10.1 c0.2,0.3,0,0.7-0.3,0.8C71.7,51.2,71.4,51.1,71.2,50.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.4,50.7c-0.2-0.2-0.2-0.4-0.1-0.7l4.6-10.2c0.1-0.3,0.5-0.5,0.8-0.3c0.3,0.1,0.5,0.5,0.3,0.8l-4.6,10.2 c-0.1,0.3-0.5,0.5-0.8,0.3C82.5,50.9,82.5,50.8,82.4,50.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,84.3c0.1,0.1,0.2,0.2,0.2,0.4l0.2,11.2c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6l-0.2-11.2 c0-0.3,0.3-0.6,0.6-0.6C77.2,84.1,77.4,84.2,77.5,84.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.1,83.1c0,0,0.1,0.1,0.1,0.1l4.9,10.1c0.2,0.3,0,0.7-0.3,0.8c-0.3,0.2-0.7,0-0.8-0.3L82,83.8 c-0.2-0.3,0-0.7,0.3-0.8C82.6,82.8,82.9,82.9,83.1,83.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.9,83.3c0.2,0.2,0.2,0.4,0.1,0.7l-4.6,10.2c-0.1,0.3-0.5,0.5-0.8,0.3c-0.3-0.1-0.5-0.5-0.3-0.8l4.6-10.2 c0.1-0.3,0.5-0.5,0.8-0.3C71.8,83.1,71.8,83.2,71.9,83.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.9,64.9l-32.4-4.4c1.1,2.3,2.2,4.5,3.3,6.8c-1.9,2.8-3.8,5.5-5.7,8.3c3.8-0.5,7.5-1,11.3-1.5 c0.4-0.1,0.8,0,1,0.3c1.5,1.2,3.1,2.3,4.6,3.5c0.3,0.2,0.7,0.3,1,0.3l6.5-0.9c0.4-0.1,0.9,0.1,1.2,0.4c0.6,0.6,1.2,1.3,1.8,1.9 c0.3,0,0.6-0.1,0.7-0.3c2.7-3.7,5.4-7.4,8.1-11.2C115.2,66.8,114.4,65.1,112.9,64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M112.9,64.9l-32.4-4.4c0.9,1.9,1.8,3.7,2.7,5.6l29.7,4c0.5-0.7,1-1.4,1.5-2.1 C115.2,66.8,114.4,65.1,112.9,64.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72,75.3c1.9-3.2,3.8-6.3,5.6-9.5l0,0c-0.8-1.6-1.7-3.2-2.5-4.8l-23.8,3.5c-1.1,0.2-1.9,1.1-1.8,2.1 c0.3,4.3,0.5,8.6,0.8,12.8c0,0.5,0.7,0.5,0.9,0.7c0.3-0.6,0.6-1.1,0.8-1.7c0.2-0.5,0.8-0.8,1.4-0.7c2.3,0.3,4.5,0.6,6.8,0.9 c0.3,0,0.7,0,1-0.2c1.8-1.3,3.7-2.6,5.5-3.9c0.3-0.2,0.8-0.3,1.2-0.2c1.3,0.4,2.7,0.8,4,1.1C71.9,75.4,71.9,75.3,72,75.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75,60.9l-24.9,3.7c-1.1,0.2-1.9,1.1-1.9,2.1c0.1,1.1,0.1,2.2,0.2,3.4c9.7-1.5,19.5-2.9,29.2-4.4 C76.7,64.1,75.9,62.5,75,60.9z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 36,
    cy: 74.3,
    r: 16.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "KeyHole",
    className: "st0",
    cx: 36,
    cy: 74.3,
    r: 7.9
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrokenKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/broken-key.7ffa74a1.svg";
export { ForwardRef as ReactComponent };